import type { AboutUsTeamMember } from "@homeinstead/schemas";

import { cn } from "@homeinstead/ui";
import { SanityImage } from "~www/components/SanityImage";

type AboutUsTeamMemberPhotoProps = {
  member: AboutUsTeamMember;
  size?: "drawer" | "row";
};

function hasOddMemberIdHash(memberId: string): boolean {
  let characterSum = 0;

  for (let index = 0; index < memberId.length; index += 1) {
    characterSum += memberId.charCodeAt(index);
  }

  return characterSum % 2 === 1;
}

function AboutUsTeamMemberPhoto({
  member,
  size = "row",
}: AboutUsTeamMemberPhotoProps) {
  const isDrawer = size === "drawer";
  const dimension = isDrawer ? 248 : 240;
  const useBlueSilhouette = hasOddMemberIdHash(member.id);

  return (
    <div
      className={cn(
        "shrink-0 overflow-hidden rounded-2xl",
        isDrawer ? "w-[248px]" : "size-60",
      )}
    >
      {!member.photo ? (
        <div
          aria-hidden
          className={cn(
            "flex h-full w-full items-end justify-center",
            useBlueSilhouette ? "bg-sky-100" : "bg-support-tints-400",
          )}
        >
          <svg
            className={cn(
              "h-[85%] w-[70%]",
              useBlueSilhouette ? "text-sky-900" : "text-new-beginnings-base",
            )}
            fill="currentColor"
            viewBox="0 0 120 140"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="60" cy="36" r="28" />
            <path d="M20 132c4-34 24-52 40-52s36 18 40 52H20z" />
          </svg>
        </div>
      ) : (
        <SanityImage
          alt={member.name}
          asset={member.photo}
          className="h-full w-full object-cover"
          height={dimension}
          width={dimension}
        />
      )}
    </div>
  );
}

export { AboutUsTeamMemberPhoto };
